var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:({
    cursor: 'url(' + _vm.pointerCursor + ', auto',
    height: _vm.imgRescaledSize[1] + 'px', 
    width: _vm.imgRescaledSize[0] + 'px',
    })},[_vm._l((_vm.doors),function(item,index){return _c('div',{key:item.name},[_c('div',{staticClass:"container-fluid"},[_c('router-link',{attrs:{"to":String(item.url)}},[_c('svg',{style:({ 
                    position: 'absolute',
                    left: _vm.svgFiles[index].position[0] + 'px',
                    top: _vm.svgFiles[index].position[1] + 'px', 
                    zIndex: 0,
                    cursor: 'url(' + _vm.pointerCursor + '), pointer'
                    }),attrs:{"xmlns":_vm.svgFiles[index].xmlns,"height":_vm.svgFiles[index].size[1],"width":_vm.svgFiles[index].size[0],"viewBox":_vm.svgFiles[index].viewBox,"fill":"none"}},[_c('path',{style:({ 
                        pointerEvents: 'all',
                        cursor: 'url(' + _vm.clickCursor + '), pointer'
                        }),attrs:{"fill":"none","d":_vm.svgFiles[index].path},on:{"mouseenter":function($event){return _vm.toggleDoorVisible(index)},"mouseleave":function($event){return _vm.toggleDoorVisible(index)}}})])])],1)])}),_c('div',{staticClass:"container-fluid",style:({ 
            backgroundImage: 'url(' + _vm.image.src + ')', 
            position: 'absolute', 
            pointerEvents: 'none', 
            height: _vm.imgRescaledSize[1] + 'px', 
            width: _vm.imgRescaledSize[0] + 'px',
            backgroundSize: _vm.imgRescaledSize[0] + 'px ' + _vm.imgRescaledSize[1] + 'px',
            top: 0,
            left: 0
            }),attrs:{"rel":"preload"}}),_vm._l((_vm.doors),function(item,index){return _c('div',{key:item.url},[(_vm.isDoorVisible[index])?_c('div',{staticClass:"container-fluid bg-img-on",style:({ 
              backgroundImage: 'url(' + _vm.doorImages[index].src + ')', 
              position: 'absolute', 
              pointerEvents: 'none', 
              height: _vm.imgRescaledSize[1] + 'px', 
              width: _vm.imgRescaledSize[0] + 'px', 
              backgroundSize: _vm.imgRescaledSize[0] + 'px ' + _vm.imgRescaledSize[1] + 'px',
              top: 0,
              left: 0
            }),attrs:{"rel":"preload"}}):_vm._e()])}),_c('transition',{attrs:{"name":"fade"}},[(_vm.showLabels)?_c('div',{staticClass:"container-fluid overlay",style:({ 
              position: 'absolute', 
              pointerEvents: 'none', 
              height: _vm.imgRescaledSize[1] + 'px', 
              width: _vm.imgRescaledSize[0] + 'px',
              backgroundSize: _vm.imgRescaledSize[0] + 'px ' + _vm.imgRescaledSize[1] + 'px',
              top: 0,
              left: 0
              }),attrs:{"rel":"preload"}}):_vm._e()])],2)}
var staticRenderFns = []

export { render, staticRenderFns }